import {cloneDeep} from 'lodash';
import {processSolrProgram} from '@nl/neu';
import moment from 'moment';

/**
 * convert program to ItemListSection
 *
 * @param program
 * @returns {{
 * duration: *,
 * releaseDisplayTime: (string|*),
 * name: *,
 * link: string, id: (null|string|number|pid)
 * }}
 */
const convertProgram = (program) => {
	const newProgram = processSolrProgram(cloneDeep(program));
	newProgram.releaseDisplayTime = moment(`${newProgram.releaseDateGMT}Z`).fromNow();
	return newProgram;
};
/**
 * convert programs to ItemListSection
 *
 * @param programs
 * @returns {*}
 */
const convertPrograms = (programs) => {
	const newPrograms = cloneDeep(programs);
	return newPrograms.map((program) => convertProgram(program));
};

export {
	convertPrograms,
	convertProgram,
};
